import React, {FC} from 'react';

interface SeparatorProps {
    vertical?: boolean;
}

const Separator: FC<SeparatorProps> = ({vertical}) => {
    const dimensionClass = vertical ? 'w-0.5 h-full' : 'h-0.5 w-full';
    return <div className={`bg-clr-on-bg-mid ${dimensionClass}`}></div>;
};

export default Separator;
